import React from 'react';
import GeneralBlueTick from '../../images/general-blue-tick.svg';

const SelectorOption = ({
	label,
	subLabel,
	icon,
	isSelected,
	onClick,
	borderRadius = '8px',
	borderSides = { top: true, right: true, bottom: true, left: true },
}) => {
	const borderStyle = (side) =>
		borderSides[side] ? '1px solid #d1d5db' : 'none';

	return (
		<div
			onClick={onClick}
			style={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				padding: '18px',
				cursor: 'pointer',
				borderTop: borderStyle('top'),
				borderRight: borderStyle('right'),
				borderBottom: borderStyle('bottom'),
				borderLeft: borderStyle('left'),
				borderRadius: borderRadius,
				backgroundColor: isSelected ? '#f0f4ff' : '#fafcfe',
				width: '100%',
				transition: 'border-color 0.3s ease',
				boxSizing: 'border-box',
			}}>
			<img
				src={isSelected ? GeneralBlueTick : icon}
				alt={label}
				style={{
					width: '20px',
					height: '20px',
				}}
			/>
			<div
				style={{
					fontSize: '14px',
					fontWeight: '700',
					color: '#111827',
					textAlign: 'center',
					margin: '8px 0',
				}}>
				{label}
			</div>
			<div
				style={{
					fontSize: '12px',
					color: '#6b7280',
					textAlign: 'center',
				}}>
				{subLabel}
			</div>
		</div>
	);
};

export default SelectorOption;
